<template>
  <div>
    <v-card outlined class="app-card">
      <v-card-title class="app-card-title">Pesquisar Veículo</v-card-title>
      <v-card-text class="app-card-content">
        <v-form ref="form" lazy-validation @submit.prevent="onSubmit">
          <v-row no-gutters>
            <v-col :md="12" :sm="12" :xs="12" cols="12">
              <v-alert type="info" border="left" dark>
                Após realizar a pesquisa por veículo, é possível gerir todas as
                suas autorizações de viagem, bem como, criar autorização de
                viagem, criar viagens e adicionar passageiros.
              </v-alert>
            </v-col>
            <v-col :md="12" :sm="12" :xs="12" cols="12">
              <v-text-field
                type="text"
                label="Placa *"
                placeholder="Ex.: GDX-1B34"
                v-mask="'AAA-#X##'"
                v-model="form.placa"
                :rules="[rules.required]"
                class="placa"
                filled
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col :md="9" :sm="9" :xs="12" cols="12" class="pt-0">
              <vue-recaptcha
                ref="recaptcha"
                :sitekey="siteKey"
                :loadRecaptchaScript="true"
                @verify="verifyRecaptcha"
                @expired="expiredRecaptcha"
                class="recaptcha"
              ></vue-recaptcha>
              <v-input v-model="form.recaptcha" :rules="[rules.required]"></v-input>
            </v-col>
            <v-col :md="3" :sm="3" :xs="12" cols="12" class="pt-0">
              <v-btn depressed block large color="primary" type="submit">Continuar</v-btn>
            </v-col>
          </v-row>
        </v-form>
        <div class="loading" v-if="isLoading">
          <v-progress-circular :size="25" color="primary" indeterminate></v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import { mask } from "vue-the-mask";

import LicencaEspecialService from "@/services/licencaEspecial.service";

import GlobalStore from "@/store/modules/global";

export default {
  name: "ConsultaForm",
  components: {
    VueRecaptcha
  },
  props: {
    transportadora: Object
  },
  directives: {
    mask
  },
  data() {
    return {
      siteKey: VUE_APP_RECAPTCHA_KEY,
      isLoading: false,
      form: {
        cnpj: null,
        token: null,
        recaptcha: null,
        placa: null
      },
      rules: {
        required: value => !!value || "Esse campo deve ser preenchido",
        pattern: value =>
          !!value.match(/^([0-9])*\/[0-9]{4}$/) ||
          "Esse campo está fora do padrão"
      }
    };
  },
  methods: {
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        this.doLogin(this.form);
      }
    },
    doLogin(form) {
      this.isLoading = true;
      LicencaEspecialService.doLogin(
        form.cnpj,
        form.recaptcha,
        form.placa
      ).subscribe(
        res => {
          this.isLoading = false;
          this.expiredRecaptcha();
          this.$router.push({
            name: "licenca-especial-veiculo",
            params: { veiculoId: res.veiculoTransportadoraId }
          });
        },
        error => {
          this.isLoading = false;
          this.expiredRecaptcha();
          GlobalStore.setSnackBar({
            show: true,
            message: error,
            type: "warning"
          });
        }
      );
    },
    initForm() {
      this.form.cnpj = this.transportadora.cnpj;
      this.form.token = this.transportadora.token;
    }
  },
  mounted() {
    this.initForm();
  }
};
</script>
